import React, { useState } from 'react';
import prophetData from '../../data/prophetResults.json';

const ProphetForecast = () => {
  const [selectedMetric, setSelectedMetric] = useState('all');

  const perf = prophetData.performance;
  const seasonal = prophetData.seasonal_pattern;
  const trend = prophetData.trend;
  const forecast = prophetData.forecast_6months;

  const monthNames = {
    '01': 'Ocak', '02': 'Şubat', '03': 'Mart', '04': 'Nisan',
    '05': 'Mayıs', '06': 'Haziran', '07': 'Temmuz', '08': 'Ağustos',
    '09': 'Eylül', '10': 'Ekim', '11': 'Kasım', '12': 'Aralık'
  };

  const formatMonth = (m) => {
    const [year, month] = m.split('-');
    return `${monthNames[month]} ${year}`;
  };

  const maxVal = Math.max(...forecast.map(f => f.upper));

  const directionTr = trend.direction === 'Artis' ? 'Artış' : trend.direction;
  const explanationTr = (trend.explanation || '')
    .replace('Yeni park abonelikleri ve alan genislemesi', 'Yeni park abonelikleri ve alan genişlemesi');

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' }}>
          AI Su Tüketim Tahmini
        </h2>
        <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
          Facebook Prophet Zaman Serisi Modeli • {prophetData.training_period} eğitim verisi
        </p>
      </div>

      {/* Açıklama Bölümü */}
      <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '12px', padding: '18px', marginBottom: '24px' }}>
        <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#0c4a6e', margin: '0 0 8px 0' }}>Bu Bölüm Ne?</h4>
        <p style={{ fontSize: '12px', color: '#374151', margin: '0 0 8px 0', lineHeight: 1.7 }}>
          Bu sayfa, <strong>ASKİ'den çekilen tüm su tüketim verilerini</strong> (100.396 kayıt, 2014-2026 arası) alıp bir yapay zeka modeli (Facebook Prophet) ile analiz eder.
          Model geçmiş tüketim kalıplarını öğrenerek <strong>gelecek 6 ay için su tüketim tahmini</strong> üretir.
        </p>
        <p style={{ fontSize: '12px', color: '#374151', margin: 0, lineHeight: 1.7 }}>
          <strong>R² = 0.99</strong> demek modelin geçmiş verinin %99'unu doğru açıkladığı, <strong>MAPE = %3.9</strong> demek ortalama sadece %3.9 hata yaptığı anlamına gelir.
          Bu tahminler sulama planlaması ve bütçe öngörüsü için kullanılır.
        </p>
      </div>

      {/* Performans Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '28px' }}>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#166534' }}>{perf.R_squared}</div>
          <div style={{ fontSize: '11px', color: '#15803d', marginTop: '4px', fontWeight: '600' }}>R² (Belirleyicilik)</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '6px', lineHeight: 1.4 }}>
            Modelin veriyi ne kadar iyi açıkladığı. 1.0 = mükemmel, 0 = rastgele. Bizimki %99 doğru.
          </div>
        </div>
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#1e40af' }}>%{perf.MAPE_percent}</div>
          <div style={{ fontSize: '11px', color: '#1d4ed8', marginTop: '4px', fontWeight: '600' }}>MAPE (Ort. Hata %)</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '6px', lineHeight: 1.4 }}>
            Ortalama yüzde hata. Ne kadar düşükse o kadar iyi. %3.9 = çok başarılı.
          </div>
        </div>
        <div style={{ background: '#fefce8', border: '1px solid #fde68a', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#92400e' }}>{Number(perf.MAE_m3).toLocaleString('tr-TR')}</div>
          <div style={{ fontSize: '11px', color: '#a16207', marginTop: '4px', fontWeight: '600' }}>MAE (m³)</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '6px', lineHeight: 1.4 }}>
            Ortalama mutlak hata. Tahmin ile gerçek arasındaki ortalama fark (m³ cinsinden).
          </div>
        </div>
        <div style={{ background: '#fdf2f8', border: '1px solid #fbcfe8', borderRadius: '10px', padding: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#9d174d' }}>{Number(perf.RMSE_m3).toLocaleString('tr-TR')}</div>
          <div style={{ fontSize: '11px', color: '#be185d', marginTop: '4px', fontWeight: '600' }}>RMSE (m³)</div>
          <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '6px', lineHeight: 1.4 }}>
            Karekök ortalama hata. Büyük hatalara daha duyarlı, kötü tahminleri yakalar.
          </div>
        </div>
      </div>

      {/* Tahmin Grafiği (Bar Chart) */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '16px', color: '#1a1a2e' }}>
          6 Aylık İleri Tahmin ({prophetData.forecast_period})
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {forecast.map((f, i) => {
            const pct = (f.predicted_m3 / maxVal) * 100;
            const lowerPct = (f.lower / maxVal) * 100;
            const upperPct = (f.upper / maxVal) * 100;
            const isMax = f.predicted_m3 === Math.max(...forecast.map(x => x.predicted_m3));
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '100px', fontSize: '12px', fontWeight: '600', color: '#374151', textAlign: 'right' }}>
                  {formatMonth(f.month)}
                </div>
                <div style={{ flex: 1, position: 'relative', height: '32px', background: '#f3f4f6', borderRadius: '6px', overflow: 'hidden' }}>
                  {/* Güven aralığı */}
                  <div style={{
                    position: 'absolute', left: `${lowerPct}%`, width: `${upperPct - lowerPct}%`,
                    height: '100%', background: 'rgba(59,130,246,0.1)', borderRadius: '4px'
                  }} />
                  {/* Ana bar */}
                  <div style={{
                    position: 'absolute', left: 0, width: `${pct}%`, height: '100%',
                    background: isMax ? 'linear-gradient(90deg, #dc2626, #ef4444)' : 'linear-gradient(90deg, #2563eb, #3b82f6)',
                    borderRadius: '6px', transition: 'width 0.5s ease'
                  }} />
                  <div style={{
                    position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
                    fontSize: '11px', fontWeight: '700', color: '#1f2937'
                  }}>
                    {Number(f.predicted_m3).toLocaleString('tr-TR')} m³
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: '16px', marginTop: '12px', fontSize: '11px', color: '#6b7280' }}>
          <span>■ Tahmin değeri</span>
          <span style={{ color: '#dc2626' }}>■ Zirve ay</span>
          <span style={{ opacity: 0.5 }}>░ %95 Güven aralığı</span>
        </div>
      </div>

      {/* Mevsimsel Analiz + Trend */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>
        {/* Mevsimsel */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '14px', color: '#1a1a2e' }}>Mevsimsel Örüntü</h3>
          <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Zirve Ayı</td>
                <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right' }}>{seasonal.peak_month} ({seasonal.peak_multiplier}x)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Düşük Ay</td>
                <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right' }}>{seasonal.low_month} ({seasonal.low_multiplier}x)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Yaz/Kış Oranı</td>
                <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right' }}>{seasonal.summer_winter_ratio}x</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Anlam</td>
                <td style={{ padding: '8px 0', fontSize: '11px', textAlign: 'right', color: '#374151' }}>Yaz aylarında kışa göre ~3,5 kat fazla su</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Trend */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '14px', color: '#1a1a2e' }}>Yıllık Trend</h3>
          <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Büyüme Oranı</td>
                <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right' }}>{trend.annual_growth_rate}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Yön</td>
                <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#dc2626' }}>↑ {directionTr}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Açıklama</td>
                <td style={{ padding: '8px 0', fontSize: '11px', textAlign: 'right', color: '#374151' }}>{explanationTr}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0', color: '#6b7280' }}>Veri Kaynağı</td>
                <td style={{ padding: '8px 0', fontSize: '11px', textAlign: 'right', color: '#374151' }}>ASKİ ({prophetData.data_source.total_records.toLocaleString('tr-TR')} kayıt)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Model Bilgileri */}
      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a2e' }}>Model Parametreleri</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', fontSize: '12px' }}>
          <div><span style={{ color: '#6b7280' }}>Model:</span> <strong>Prophet</strong></div>
          <div><span style={{ color: '#6b7280' }}>Mevsimsellik:</span> <strong>{prophetData.model_parameters.seasonality_mode}</strong></div>
          <div><span style={{ color: '#6b7280' }}>Yıllık:</span> <strong>{prophetData.model_parameters.yearly_seasonality ? 'Aktif' : 'Kapalı'}</strong></div>
          <div><span style={{ color: '#6b7280' }}>Changepoint:</span> <strong>{prophetData.model_parameters.changepoint_prior_scale}</strong></div>
          <div><span style={{ color: '#6b7280' }}>Seasonality Prior:</span> <strong>{prophetData.model_parameters.seasonality_prior_scale}</strong></div>
          <div><span style={{ color: '#6b7280' }}>Tatiller:</span> <strong>{prophetData.model_parameters.country_holidays} (Türkiye)</strong></div>
        </div>
      </div>

      {/* Tahmin Detay Tablosu */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', marginTop: '20px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a2e' }}>Detaylı Tahmin Tablosu</h3>
        <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #1a1a2e' }}>
              <th style={{ padding: '8px', textAlign: 'left' }}>Dönem</th>
              <th style={{ padding: '8px', textAlign: 'right' }}>Tahmin (m³)</th>
              <th style={{ padding: '8px', textAlign: 'right' }}>Alt Sınır (%95)</th>
              <th style={{ padding: '8px', textAlign: 'right' }}>Üst Sınır (%95)</th>
              <th style={{ padding: '8px', textAlign: 'right' }}>Güven Aralığı</th>
            </tr>
          </thead>
          <tbody>
            {forecast.map((f, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#f9fafb' }}>
                <td style={{ padding: '8px', fontWeight: '600' }}>{formatMonth(f.month)}</td>
                <td style={{ padding: '8px', textAlign: 'right', fontWeight: '700' }}>{Number(f.predicted_m3).toLocaleString('tr-TR')}</td>
                <td style={{ padding: '8px', textAlign: 'right', color: '#6b7280' }}>{Number(f.lower).toLocaleString('tr-TR')}</td>
                <td style={{ padding: '8px', textAlign: 'right', color: '#6b7280' }}>{Number(f.upper).toLocaleString('tr-TR')}</td>
                <td style={{ padding: '8px', textAlign: 'right', color: '#9ca3af' }}>±{Number(f.upper - f.lower).toLocaleString('tr-TR')}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: '2px solid #1a1a2e', fontWeight: '700' }}>
              <td style={{ padding: '8px' }}>TOPLAM</td>
              <td style={{ padding: '8px', textAlign: 'right' }}>{Number(forecast.reduce((a, f) => a + f.predicted_m3, 0)).toLocaleString('tr-TR')}</td>
              <td style={{ padding: '8px', textAlign: 'right', color: '#6b7280' }}>{Number(forecast.reduce((a, f) => a + f.lower, 0)).toLocaleString('tr-TR')}</td>
              <td style={{ padding: '8px', textAlign: 'right', color: '#6b7280' }}>{Number(forecast.reduce((a, f) => a + f.upper, 0)).toLocaleString('tr-TR')}</td>
              <td style={{ padding: '8px', textAlign: 'right' }}></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default ProphetForecast;
